/*===================================================================
=     use USER           =
====================================================================*/
/**
 * use User 
 * 
 * Give access and manage user Data
 */

import useErrorHandler from "../../../hook/useErrorHandler"
import { useGenericAPI, useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI"
import { User } from "../../spendingDemand/components/SingleSpendingDemand/GeneralInfo/GeneralInfoView/GeneralInfoView"
import { Team } from "../../team/types/team.types"
import { BASE_USER_API, GET_BASE_URL_CURRENT_USER_TEAM_MANAGERS, GET_BASE_URL_CURRENT_USER_TEAM_MEMBERS } from "../services/user.api"

import useUserCore from "./useUserCore"

export const useUser = () => {
    const {handleInternError, handleNetworkError} = useErrorHandler()
    return useUserCore(handleNetworkError,handleInternError)
}

export const useSingleUser = (userId: string) => {
    return useSingleGenericAPI<User, Partial<User>>({
      baseURL: BASE_USER_API,
      APIname: "user",
      id: userId,
    })
}

export const useCurrentUserTeam = ({role}: { role: 'member' | 'manager' }) => {

 const useCurrentUserTeamQuery = useGenericAPI<Team, Partial<Team>, Partial<Team>>({
    baseURL: role === 'member' ? GET_BASE_URL_CURRENT_USER_TEAM_MEMBERS : GET_BASE_URL_CURRENT_USER_TEAM_MANAGERS,
    APIname: "user-team",
  })

  return {getTeamListQuey: useCurrentUserTeamQuery.getAllQuery }
}